@if (bannersWithButton$ | async; as bannersWithButton) {
  @if (bannersWithButton.label && bannersWithButton.banners.length) {
    <h2 class="text-b2-s text-md-b2-m text-lg-h4-s banner-with-button-title container-v2">
      {{ bannersWithButton.label }}
    </h2>
    <div class="banner-with-button-container container-v2">
      @for (banner of bannersWithButton.banners; track banner.url) {
        <sd-banner-with-button-item
          [banner]="banner"
          [isDesktop]="isDesktop$ | async"
          [isTablet]="isTablet$ | async"
          [sdInViewport]="0.5"
          [intersectedOnce]="true"
          (intersected)="onBannerIntersect(banner)"
        ></sd-banner-with-button-item>
      }
    </div>
  }
} @else if (isLoading$ | async) {
  <div class="container-v2 sd-group-skeleton-gradient-wave">
    <div class="banner-with-button-title sd-skeleton"></div>
    <div class="banner-with-button-container">
      @let numberOfSkeletons = 3;
      @for (i of [].constructor(numberOfSkeletons); track $index) {
        <div class="banner-with-button sd-skeleton"></div>
      }
    </div>
  </div>
}
